export default function DokumentationPage() {
  return (
    <div className="max-w-5xl mx-auto space-y-8 pb-12">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl p-8 text-white">
        <h1 className="text-3xl font-bold mb-2">Lead Management System</h1>
        <p className="text-blue-100">Komplette Dokumentation aller Funktionen</p>
        <p className="text-sm text-blue-200 mt-4">
          Version 2.0 • Letzte Aktualisierung: {new Date().toLocaleDateString('de-DE', { year: 'numeric', month: 'long', day: 'numeric' })}
        </p>
      </div>

      {/* Inhaltsverzeichnis */}
      <div className="bg-white border border-gray-200 rounded-lg p-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">Inhaltsverzeichnis</h2>
        <nav className="space-y-2">
          <a href="#crm" className="block text-blue-600 hover:text-blue-700 text-sm">1. CRM (Vertrieb & Pipeline)</a>
          <a href="#todos" className="block text-blue-600 hover:text-blue-700 text-sm ml-4">1.1 Leads (Kaltakquise)</a>
          <a href="#todos" className="block text-blue-600 hover:text-blue-700 text-sm ml-4">1.2 Anfragen (Pipeline)</a>
          <a href="#todos" className="block text-blue-600 hover:text-blue-700 text-sm">2. To-Do's & Aufgabenverwaltung</a>
          <a href="#pakete" className="block text-blue-600 hover:text-blue-700 text-sm">3. Aufgabenpakete</a>
          <a href="#kunden" className="block text-blue-600 hover:text-blue-700 text-sm">4. Kundenverwaltung</a>
          <a href="#projekte" className="block text-blue-600 hover:text-blue-700 text-sm">5. Projektverwaltung</a>
          <a href="#leads" className="block text-blue-600 hover:text-blue-700 text-sm">6. Projekt-Leads</a>
          <a href="#formulare" className="block text-blue-600 hover:text-blue-700 text-sm">7. Formular-Eingänge</a>
          <a href="#statistiken" className="block text-blue-600 hover:text-blue-700 text-sm">8. Statistiken & Auswertungen</a>
          <a href="#analytics" className="block text-blue-600 hover:text-blue-700 text-sm">9. Analytics & SEO-Optimierungs-Maschine</a>
          <a href="#analytics-tracking" className="block text-blue-600 hover:text-blue-700 text-sm ml-4">9.1 Besucher-Tracking (cookiefrei, inkl. Events)</a>
          <a href="#analytics-gsc" className="block text-blue-600 hover:text-blue-700 text-sm ml-4">9.2 Google Search Console & PUBLIVO</a>
          <a href="#analytics-empfehlungen" className="block text-blue-600 hover:text-blue-700 text-sm ml-4">9.3 KI-Empfehlungen & Feedback-Schleife</a>
          <a href="#analytics-waechter" className="block text-blue-600 hover:text-blue-700 text-sm ml-4">9.4 Wächter (Rankings, Erreichbarkeit, PageSpeed)</a>
          <a href="#analytics-report" className="block text-blue-600 hover:text-blue-700 text-sm ml-4">9.5 Monats-Report für Kunden</a>
        </nav>
      </div>

      {/* CRM */}
      <Section id="crm" title="1. CRM (Vertrieb & Pipeline)" icon="📊">
        <p className="text-gray-700 mb-4">
          Das CRM-System ist das Herzstück Ihrer Vertriebsarbeit. Es ist in drei Bereiche unterteilt:
        </p>

        <SubSection title="Kaltakquise (Leads)">
          <p className="text-gray-700 mb-3">
            Verwalten Sie potenzielle Kunden aus Ihrer Kaltakquise. Tracken Sie Kontakte und konvertieren Sie Leads zu Anfragen oder direkt zu Kunden.
          </p>
          <FeatureList items={[
            'Lead anlegen mit Firmenname, Ansprechpartner, Kontaktdaten',
            'Status-Tracking: Neu → Kontaktiert → Interessiert → Gewonnen/Kein Interesse',
            'Nächsten Kontakttermin festlegen mit automatischer Erinnerung',
            'Notizen und Gesprächsverläufe dokumentieren',
            'Lead zu Anfrage konvertieren (weiter in die Pipeline)',
            'Lead direkt zu Kunde konvertieren (bei sofortiger Zusage)',
          ]} />
        </SubSection>

        <SubSection title="Qualifizierte Leads">
          <p className="text-gray-700 mb-3">
            Leads die echtes Interesse gezeigt haben werden hier angezeigt. Sie sind bereits kontaktiert und haben positives Feedback gegeben.
          </p>
        </SubSection>

        <SubSection title="Anfragen (Pipeline)">
          <p className="text-gray-700 mb-3">
            Verwalten Sie konkrete Anfragen von Google Ads, Empfehlungen oder aus der Kaltakquise. Tracken Sie den Angebotsstatus und Nachfass-Termine.
          </p>
          <FeatureList items={[
            'Anfrage anlegen mit Quelle (Google Ads, Empfehlung, etc.)',
            'Interesse/Bedarf des Kunden dokumentieren',
            'Angebotsdatum und Nachfass-Datum festlegen',
            'Status: Neu → In Bearbeitung → Angebot erstellt → Nachgefasst → Gewonnen/Verloren',
            'Automatische Erinnerung bei fälligen Nachfass-Terminen',
            'Bei Gewinn: Automatische Konvertierung zum Kunden',
          ]} />
        </SubSection>

        <Alert type="success" title="Automatische Konvertierung">
          Wenn Sie einen Lead oder eine Anfrage als "Gewonnen" markieren, wird automatisch ein neuer Kunde in den Kundenstammdaten angelegt und Sie werden zu den To-Do's weitergeleitet.
        </Alert>
      </Section>

      {/* To-Dos */}
      <Section id="todos" title="2. To-Do's & Aufgabenverwaltung" icon="✅">
        <p className="text-gray-700 mb-4">
          Organisieren Sie alle Aufgaben zentral – sortiert nach Projekten oder als allgemeine To-Do's.
        </p>

        <SubSection title="Allgemeine Aufgaben">
          <p className="text-gray-700 mb-3">
            Erstellen Sie Aufgaben, die nicht direkt einem Projekt zugeordnet sind (z.B. administrative Tätigkeiten, Akquise-Vorbereitung).
          </p>
        </SubSection>

        <SubSection title="Projekt-Aufgaben">
          <p className="text-gray-700 mb-3">
            Alle Projekte werden automatisch importiert. Jedes Projekt hat eine eigene Sektion mit Fortschrittsanzeige.
          </p>
          <FeatureList items={[
            'Aufgaben direkt beim Projekt hinzufügen',
            'Aufgabenpakete zuweisen (vordefinierte To-Do-Listen)',
            'Fortschritt wird automatisch berechnet (Erledigt/Gesamt)',
            'Deadline-Tracking mit visuellen Warnungen bei Überfälligkeit',
            'Sortierung: Offene Aufgaben zuerst, dann nach Deadline',
          ]} />
        </SubSection>

        <Alert type="info" title="Projekt-Import">
          Wenn Sie in "Projekte" ein neues Projekt anlegen, erscheint es automatisch in den To-Do's. Sie können dann sofort Aufgaben zuweisen oder ein Paket anwenden.
        </Alert>
      </Section>

      {/* Aufgabenpakete */}
      <Section id="pakete" title="3. Aufgabenpakete" icon="📦">
        <p className="text-gray-700 mb-4">
          Definieren Sie wiederverwendbare To-Do-Pakete für wiederkehrende Prozesse (z.B. Bewerbungspaket, Lead-Generierung, Onboarding).
        </p>

        <FeatureList items={[
          'Paket erstellen mit Name und Beschreibung',
          'Beliebig viele Aufgaben zum Paket hinzufügen',
          'Pakete bearbeiten oder löschen',
          'Pakete einem Projekt zuweisen → Alle Aufgaben werden automatisch erstellt',
          'Spart Zeit bei wiederkehrenden Prozessen',
        ]} />

        <CodeExample title="Beispiel: Bewerbungspaket">
          {`Paket-Name: Bewerbungspaket Fenstermonteur
Beschreibung: Standard-Prozess für Mitarbeitergewinnung

Aufgaben:
• Stellenanzeige schalten (Indeed, StepStone)
• Google Ads Kampagne aktivieren
• Social Media Posts erstellen
• Bewerbungen sichten
• Kandidaten kontaktieren
• Vorstellungsgespräche führen
• Zusage versenden`}
        </CodeExample>
      </Section>

      {/* Kunden */}
      <Section id="kunden" title="4. Kundenverwaltung" icon="👥">
        <p className="text-gray-700 mb-4">
          Zentrale Verwaltung aller Kunden mit Kontaktdaten und Projektzuordnung.
        </p>

        <FeatureList items={[
          'Kunden anlegen mit Name, Slug (URL), Forward-E-Mail',
          'Kunden bearbeiten oder löschen',
          'Übersicht: Anzahl Projekte pro Kunde',
          'Filter: Nach Kunde suchen',
          'Automatische Erstellung aus CRM (bei gewonnenem Deal)',
        ]} />

        <Alert type="warning" title="Wichtig: Slug">
          Der Slug ist die eindeutige URL-Kennung des Kunden (z.B. "schreinerei-thomas"). Dieser wird für die Projekt-Integration und Lead-Zuordnung verwendet.
        </Alert>
      </Section>

      {/* Projekte */}
      <Section id="projekte" title="5. Projektverwaltung" icon="📁">
        <p className="text-gray-700 mb-4">
          Verwalten Sie alle Projekte (Kampagnen, Aufträge) und ordnen Sie sie Kunden zu.
        </p>

        <FeatureList items={[
          'Projekt erstellen mit Name, Kunde, Slug',
          'Projekte aktivieren/deaktivieren',
          'Integrationscode abrufen (für externe Lead-Formulare)',
          'Projekte bearbeiten oder löschen',
          'Filter: Nach Kunde filtern',
          "Automatischer Import in To-Do's",
        ]} />

        <SubSection title="Projekt-Integration">
          <p className="text-gray-700 mb-3">
            Jedes Projekt kann einen eigenen Lead-Erfassungs-Endpunkt haben. Klicken Sie auf "Integration" um den Code zu erhalten.
          </p>
        </SubSection>
      </Section>

      {/* Projekt-Leads */}
      <Section id="leads" title="6. Projekt-Leads" icon="📋">
        <p className="text-gray-700 mb-4">
          Alle Leads die über Ihre externen Formulare (Projekt-Integration) eingehen, werden hier angezeigt.
        </p>

        <FeatureList items={[
          'Übersicht aller eingehenden Leads',
          'Zuordnung zu Projekt und Kunde',
          'Lead-Daten (Name, E-Mail, Telefon, Custom Fields)',
          'Status-Tracking: Neu, In Bearbeitung, Qualifiziert, Konvertiert, Abgelehnt',
          'Filter: Nach Kunde, Projekt, Status, Datum',
          'Suche: In Name und E-Mail',
          'Export: Lead-Details als Text',
        ]} />
      </Section>

      {/* Formulare */}
      <Section id="formulare" title="7. Formular-Eingänge" icon="📝">
        <p className="text-gray-700 mb-4">
          Zentrale Formulare (Lead-Generierung, Recruiting) die manuell Kunden zugeordnet werden.
        </p>

        <FeatureList items={[
          'Eingehende Formular-Submissions von Ihrer Website',
          'Zwei Typen: Lead-Generierung & Recruiting',
          'Manuelle Kundenzuordnung durch Admin',
          'Datei-Uploads (z.B. Lebensläufe, Bewerbungsunterlagen)',
          'Status: Neu, In Bearbeitung, Abgeschlossen, Archiviert',
          'Notizen und Tags hinzufügen',
          'Download als Textdatei (nur Fragen & Antworten)',
        ]} />

        <Alert type="info" title="API-Endpunkt">
          Formulare senden Daten an: <code>https://fuxdkfjqzcszkxejndgw.supabase.co/functions/v1/submit-form</code>
        </Alert>
      </Section>

      {/* Statistiken */}
      <Section id="statistiken" title="8. Statistiken & Auswertungen" icon="📈">
        <p className="text-gray-700 mb-4">
          Analysieren Sie Ihre Vertriebskennzahlen und verfolgen Sie wichtige KPIs.
        </p>

        <FeatureList items={[
          'Zeitraum-Filter: Heute, Diese Woche, Dieser Monat, Dieses Jahr, Benutzerdefiniert',
          'Lead-Konversionsrate (Leads → Kunden)',
          'Anfragen-Erfolgsquote (Anfragen → Gewonnen)',
          'Pipeline-Wert & Deal-Statistiken',
          'Aufgaben-Übersicht (Offen, Fällig, Erledigt)',
          'Projekt-Performance',
          'Formular-Eingänge nach Typ',
          'Entwicklung über Zeit (Charts)',
        ]} />
      </Section>

      {/* Best Practices */}
      <Section title="Best Practices & Workflow" icon="💡">
        <div className="space-y-4">
          <WorkflowStep number={1} title="Lead-Akquise">
            Erfassen Sie neue Kontakte als Lead im CRM → Setzen Sie Kontakttermin → Dokumentieren Sie Gespräche
          </WorkflowStep>

          <WorkflowStep number={2} title="Qualifizierung">
            Bei Interesse: Konvertieren Sie Lead zu Anfrage → Erstellen Sie Angebot → Setzen Sie Nachfass-Termin
          </WorkflowStep>

          <WorkflowStep number={3} title="Abschluss">
            Bei Zusage: Markieren Sie Anfrage als "Gewonnen" → Kunde wird automatisch angelegt → Sie werden zu To-Do's weitergeleitet
          </WorkflowStep>

          <WorkflowStep number={4} title="Projekt-Start">
            Legen Sie Projekt an → Wenden Sie Aufgabenpaket an → Arbeiten Sie To-Do's ab → Tracken Sie Fortschritt
          </WorkflowStep>

          <WorkflowStep number={5} title="Monitoring">
            Prüfen Sie regelmäßig Statistiken → Identifizieren Sie Engpässe → Optimieren Sie Prozesse
          </WorkflowStep>
        </div>
      </Section>

      {/* Analytics & SEO-Optimierungs-Maschine */}
      <Section id="analytics" title="9. Analytics & SEO-Optimierungs-Maschine" icon="📈">
        <p className="text-gray-700 mb-4">
          Der Analytics-Bereich ist mehr als eine Statistik-Seite: Er sammelt alle Daten der Kunden-Websites
          (Besucher, Google-Suche, Blog, Lead-Qualität), erzeugt daraus konkrete Optimierungs-Empfehlungen,
          hilft bei der Umsetzung und <strong>misst danach automatisch, ob die Umsetzung gewirkt hat</strong> —
          eine geschlossene Feedback-Schleife. Kunden sehen nur ihre eigenen Zahlen (Übersicht/SEO/Blog);
          alles Weitere (Empfehlungen, Wächter, Reports) ist nur für den Admin sichtbar.
        </p>

        <SubSection title="9.1 Besucher-Tracking (cookiefrei, inkl. Events)" >
          <FeatureList items={[
            'Eigenes First-Party-Tracking über t.js – KEINE Cookies, KEIN Consent-Banner nötig (täglich rotierender Besucher-Hash, keine IP-Speicherung)',
            'Kanäle automatisch erkannt: Google organisch, Google Ads (gclid), KI-Suche (ChatGPT, Perplexity, Copilot, Gemini, Claude), Social, Verweise, Direkt',
            'Konversionsrate = Leads ÷ Besucher, pro Kanal und pro Landing Page',
            'Events (v2): Klicks auf Telefon/E-Mail/CTA-Buttons (data-track-Attribut), ausgehende Links',
            'Verweildauer (echte aktive Zeit im Tab) und Scrolltiefe pro Seite',
            'Damit unterscheidbar: SEO-Problem (kein Traffic) vs. Conversion-Problem (Traffic, aber keine Kontakt-Klicks)',
          ]} />
          <CodeExample title="Einbindung auf einer Kunden-Website (einmalig)">
{`<script src="https://dashboard.nico-els.de/t.js" data-site="KUNDEN-SLUG" defer></script>
<!-- CTA-Buttons optional markieren: -->
<a href="/anfrage" data-track="angebot">Jetzt Angebot anfordern</a>`}
          </CodeExample>
        </SubSection>

        <SubSection title="9.2 Google Search Console & PUBLIVO">
          <FeatureList items={[
            'Nächtlicher Sync (03:00 UTC) pro Projekt mit gsc_property: Klicks, Impressionen, Position – gesamt, pro Suchanfrage, pro Seite',
            '16 Monate Historie → Saisonalitäts-Vergleich mit dem Vorjahr (verhindert Fehlalarme in der Nebensaison)',
            'PUBLIVO-Blog-Konnektor pro Projekt: Artikel-Leistung (welcher Artikel bringt welche Google-Klicks), Themensäulen-Kontext',
            'Lead-Qualität: Jeder Lead kann als „Auftrag / Nichts geworden / Spam" bewertet werden (Lead-Detailseite) → Analytics weiß, welche Seite/Quelle AUFTRÄGE bringt, nicht nur Anfragen',
          ]} />
        </SubSection>

        <SubSection title="9.3 KI-Empfehlungen & Feedback-Schleife (nur Admin)">
          <p className="text-gray-700 mb-3">
            Tab „✨ Empfehlungen" (Projekt auswählen): Claude Opus 5 analysiert auf Knopfdruck alle Signale
            und erzeugt strukturierte, einzeln abarbeitbare Empfehlungen mit Datenbezug.
          </p>
          <FeatureList items={[
            'Signale: Quick Wins (Pos. 11–20), niedrige Klickrate, Content-Lücken, Kannibalisierung (2 Seiten ranken für dieselbe Query), Engagement-Befunde, Lead-Qualität, KI-Traffic, Saisonalität, frühere Ergebnisse',
            'Website-Empfehlung → Button „Prompt für Claude Code kopieren": fertiger Auftrag zum Einfügen im jeweiligen Website-Repo',
            'PUBLIVO-Empfehlung → Button „Säule in PUBLIVO nachschärfen": schreibt die verbesserte Themensäule direkt nach PUBLIVO (alte Fassung wird gesichert). Regel: Nachschärfen ist Standard, NEUE Säule nur bei echter Lücke (markierte Ausnahme mit Extra-Bestätigung)',
            'Jede Empfehlung: „Umgesetzt" / „Verwerfen" – der Umgesetzt-Zeitpunkt ist der Anker für die Wirkungsmessung',
            'Wirkungs-Bewertung: Nach ~3 Wochen vergleicht die nächste Runde automatisch Klickrate/Position vorher vs. nachher → Badge „✓ hat gewirkt" / „keine messbare Wirkung" – und die KI lernt daraus für künftige Vorschläge',
          ]} />
          <Alert type="warning" title="Wichtig für die Schleife">
            Nach dem Umsetzen eines Website-Prompts in Claude Code die Empfehlung im LMS auf „Umgesetzt" setzen –
            sonst kann die Wirkung nicht zugeordnet werden.
          </Alert>
        </SubSection>

        <SubSection title="9.4 Wächter (automatisch, nächtlich)">
          <FeatureList items={[
            'Ranking-Wächter: Absturz einer relevanten Suchanfrage (Ø-Position 7 Tage vs. 28 Tage davor, ≥3 Positionen schlechter) → Meldung',
            'Erreichbarkeits-Wächter: Top-10-Seiten werden per HTTP geprüft – kaputte Seite (4xx/5xx/Timeout) → kritische Meldung',
            'PageSpeed-Wächter (optional): montags mobiler PageSpeed der Startseite, unter 60/100 → Meldung (benötigt PAGESPEED_API_KEY in Vercel)',
            'Meldungen erscheinen oben im Empfehlungen-Tab und lassen sich mit „Erledigt" quittieren; Deduplizierung pro Kalenderwoche',
          ]} />
        </SubSection>

        <SubSection title="9.5 Monats-Report für Kunden (nur Admin)">
          <FeatureList items={[
            'Unten im Empfehlungen-Tab: Monat wählen → „Report erstellen"',
            'Kundenfreundliche einfache Sprache (keine Fachbegriffe), immer mit Vormonats-Vergleich, ehrlich eingeordnet',
            'Inhalt: Besucher, Google-Entwicklung, Anfragen (inkl. gewonnene Aufträge), umgesetzte Optimierungen, Ausblick',
            'Ein Klick „Kopieren" → in die Kunden-E-Mail einfügen. Ersetzt den handgeschriebenen Bericht.',
          ]} />
        </SubSection>

        <Alert type="info" title="Rollen & Sichtbarkeit">
          Kunde: Übersicht, SEO/Google und Blog – nur eigene Daten. Admin: zusätzlich Kunden-Aggregat,
          Empfehlungen, Wächter, Monats-Reports. Diese Dokumentation und alle Admin-Seiten sind auch bei
          direktem URL-Aufruf geschützt (AdminRoute).
        </Alert>
      </Section>

      {/* Footer */}
      <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 text-center">
        <p className="text-sm text-gray-600">
          Bei Fragen oder Problemen wenden Sie sich an den System-Administrator.
        </p>
        <p className="text-xs text-gray-400 mt-2">
          © {new Date().getFullYear()} Lead Management System • Entwickelt für Nico Els
        </p>
      </div>
    </div>
  );
}

// =============================================
// COMPONENTS
// =============================================

function Section({ id, title, icon, children }: { id?: string; title: string; icon: string; children: React.ReactNode }) {
  return (
    <section id={id} className="bg-white border border-gray-200 rounded-lg p-6 scroll-mt-4">
      <h2 className="text-xl font-semibold text-gray-900 mb-4 flex items-center gap-2">
        <span className="text-2xl">{icon}</span>
        {title}
      </h2>
      {children}
    </section>
  );
}

function SubSection({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="mt-4 pl-4 border-l-2 border-blue-200">
      <h3 className="text-sm font-semibold text-gray-800 mb-2">{title}</h3>
      {children}
    </div>
  );
}

function FeatureList({ items }: { items: string[] }) {
  return (
    <ul className="space-y-2">
      {items.map((item, idx) => (
        <li key={idx} className="flex items-start gap-2 text-sm text-gray-700">
          <svg className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span>{item}</span>
        </li>
      ))}
    </ul>
  );
}

function Alert({ type, title, children }: { type: 'info' | 'success' | 'warning'; title: string; children: React.ReactNode }) {
  const colors = {
    info: 'bg-blue-50 border-blue-200 text-blue-800',
    success: 'bg-green-50 border-green-200 text-green-800',
    warning: 'bg-amber-50 border-amber-200 text-amber-800',
  };

  return (
    <div className={`mt-4 border rounded-lg p-4 ${colors[type]}`}>
      <p className="font-medium text-sm mb-1">{title}</p>
      <div className="text-sm opacity-90">{children}</div>
    </div>
  );
}

function CodeExample({ title, children }: { title: string; children: string }) {
  return (
    <div className="mt-4">
      <p className="text-xs text-gray-500 uppercase tracking-wide mb-2">{title}</p>
      <pre className="bg-gray-900 text-gray-100 text-xs p-4 rounded-lg overflow-x-auto">
        {children}
      </pre>
    </div>
  );
}

function WorkflowStep({ number, title, children }: { number: number; title: string; children: React.ReactNode }) {
  return (
    <div className="flex gap-4">
      <div className="flex-shrink-0 w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center font-semibold text-sm">
        {number}
      </div>
      <div className="flex-1 pt-1">
        <h4 className="font-medium text-gray-900 text-sm mb-1">{title}</h4>
        <p className="text-sm text-gray-600">{children}</p>
      </div>
    </div>
  );
}
